import type { CaptureFileJSONObject } from '@ikegps/core-api';
import { IkeRestObject } from './base';

export class IkeObjectCapture extends IkeRestObject<CaptureFileJSONObject> {
	className = 'Capture' as const;
	actionName = 'capture';
	object: CaptureFileJSONObject;

	constructor() {
		super();
		this.cacheKeys['uuid'] = true;
	}
}
